// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/App/Static/Menu/MenuBar.scss
// module id = 8279
// module chunks = 2